import React from 'react';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';
import itLocale from '@fullcalendar/core/locales/it';

import { useTranslation } from 'react-i18next';
import { languages } from 'constants/languages';
import { RenderItem } from './styled';

const renderEventContent = (eventInfo) => { 
  return (
    <RenderItem bgColor={eventInfo.backgroundColor} onClick={() => window.history.pushState(eventInfo.event.url)}>
      <span style={{ fontWeight: 'bold', marginRight: 2 }}>{eventInfo.timeText}</span>
      <span>{eventInfo.event.title}</span>
    </RenderItem>
  );
};

const Calendar = ({ data }) => {
  const { i18n } = useTranslation();
  return (
    <FullCalendar
      //TODO configure multi lang
      // locale={i18n.language}
      locale={languages.itKey}
      locales={[itLocale, esLocale]}
      headerToolbar={{ right: 'dayGridMonth,timeGridWeek,timeGridDay',
        center: 'title',
        left: 'prev,next today'
      }}
      events={data}
      plugins={[dayGridPlugin, timeGridPlugin]}
      initialView='dayGridMonth'
      eventContent={renderEventContent}
    />
  );
};

export default Calendar;
